import { Button } from "../../components/Button/Button";
import "./LeafLinkButton.scss";

type Props = {
  onClick: React.MouseEventHandler<HTMLButtonElement | HTMLAnchorElement>;
  disabled?: boolean;
  label: string;
  as: "link" | "button";
  children: any;
  fontSize?: "small" | "normal" | "medium" | "big" | "huge" | "large";
  fontWeight?: "thin" | "regular" | "medium" | "bold";
  theme?: "white" | "black" | "green" | "blue" | "purple";
  show?: boolean;
  underlined?: boolean;
};

const LeafLinkButton = ({
  onClick,
  disabled = false,
  label,
  children,
  as = "link",
  fontWeight,
  fontSize,
  theme = as === "link" ? "black" : "white",
  show = true,
  underlined = true,
}: Props) => {
  const commonProps = {
    onClick,
    disabled,
    "aria-label": label,
    "aria-disabled": disabled,
    role: as,
  };

  if (show === true) {
    return (
      <>
        <Button
          className={`leaf-link-button leaf-link-button__${as} 
            leaf-link-button__${as}__theme-${theme}${disabled === true ? "--disabled" : "--enabled"} 
            ${as === "link" ? `leaf-link-button__link__underline${underlined ? "--enabled" : "disabled"}` : ""} 
            ${fontSize ? `leaf-link-button--${fontSize} ` : ""}
            ${fontWeight ? `leaf-link-button--${fontWeight}` : ""}
          `}
          {...commonProps}
        >
          {children}
        </Button>
      </>
    );
  }

  return <></>;
};

export default LeafLinkButton;
